// Die festen Element-Kennungen des Kontaktdetails. Browserproben und
// Fokusfuehrung verlassen sich auf sie; kontakt.tsx exportiert sie weiter.

export const NOTE_INPUT_ID = 'kontakt-notiz';
export const HISTORY_STATUS_ID = 'kontakt-verlauf-status';
/** Der Abschnitt "Stichworte" (ST-TAX-002, erster Schnitt; ADR-0053). */
export const CLASSIFICATION_INPUT_ID = 'kontakt-stichwort';
export const CLASSIFICATION_STATUS_ID = 'kontakt-stichworte-status';
export const FOLLOW_UP_DATE_ID = 'kontakt-wiedervorlage-termin';
/** Die Auswahl "Wiedervorlage" im Notizkasten; Ziel von "Wiedervorlage" im Kopf. */
export const FOLLOW_UP_CHOICE_ID = 'kontakt-wiedervorlage-wahl';
export const ROLE_INPUT_ID = 'kontakt-rolle';
export const ROLE_STATUS_ID = 'kontakt-zugehoerigkeit-status';
/** Die Auswahl "Neue Rolle" einer Rolle, die gerade geaendert wird (ADR-0057). */
export const roleChangeInputId = (contextRoleAssignmentId: string): string => `kontakt-rolle-neu-${contextRoleAssignmentId}`;
export const roleChangeButtonId = (contextRoleAssignmentId: string): string => `kontakt-rolle-aendern-${contextRoleAssignmentId}`;
export const FOLLOW_UP_TITLE_ID = 'kontakt-wiedervorlage-titel';
/** Der Abschnitt "Beziehungen" (ST-REL-001; ADR-0061 Ziffer 17). */
export const RELATIONSHIP_STATUS_ID = 'kontakt-beziehungen-status';
export const RELATIONSHIP_READING_INPUT_ID = 'kontakt-beziehung-art';
export const RELATIONSHIP_SEARCH_INPUT_ID = 'kontakt-beziehung-suche';
export const RELATIONSHIP_HITS_ID = 'kontakt-beziehung-treffer';

/** Registerleiste und ihre Panels (register.tsx); hier, damit der Verlauf ins Register "Verlauf" zeigen kann. */
export function panelId(id: string): string {
  return `register-panel-${id}`;
}

export function tabId(id: string): string {
  return `register-${id}`;
}
